import React from 'react';
import { observer } from 'mobx-react';

import { InjectedStyledComponent } from '../../../../../shared/index.js';
import Tooltip from '../../../Tooltip/Tooltip.js';
import { TranslationContext } from '../../../Translate/Translate.js';
import { ITableEvents } from '../../models/index.js';
import Superscript from '../../styledComponents/Superscript.js';
import CellValue from '../CellValue/CellValue.js';
import { TableComponentBase } from '../TableComponentBase.js';

import { IRowHeadCellConfiguration, IRowHeadCellProps, IRowHeadCellState } from './models/index.js';
import {
	ROW_HEAD_CELL_CATEGORY_KEY,
	ROW_HEAD_CELL_COMPONENT_KEY,
	ROW_HEAD_CELL_PARENT_COMPONENT_KEY,
} from './RowHeadCell.meta.js';

export class RowHeadCell extends TableComponentBase<
	IRowHeadCellProps & React.TdHTMLAttributes<HTMLTableHeaderCellElement>,
	IRowHeadCellState,
	IRowHeadCellConfiguration
> {
	categoryKey = ROW_HEAD_CELL_CATEGORY_KEY;
	componentKey = ROW_HEAD_CELL_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return ROW_HEAD_CELL_PARENT_COMPONENT_KEY;
	}

	get tableEventsKey(): keyof ITableEvents {
		return 'rowHeadCell';
	}

	constructor(props: IRowHeadCellProps) {
		super(props);
	}

	render() {
		const {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			children,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			configuration,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyle,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyleProps,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			table,

			cellValue,
			column,
			columnIndex,
			row,
			rowIndex,
			...otherProps
		} = this.props;
		const superscripts = this.table.logic.getCellSuperscripts(column, row);
		const tooltipProps = this.getTooltipRowProps(row, column);
		const events = this.getEvents(this.eventsForElement, row, rowIndex, column, columnIndex, cellValue);
		const cellValueComponent = <CellValue table={this.table} cellValue={cellValue} column={column} />;
		if (!superscripts && !tooltipProps) {
			return (
				<th {...events} {...otherProps} scope="row">
					{cellValueComponent}
				</th>
			);
		}

		return (
			<TranslationContext.Consumer>
				{(translationContext) => {
					const ariaProps: any = {};
					// set up aria-label so that VO announces just the cellValue instead of the tooltips as well
					ariaProps['aria-label'] = translationContext.translate(cellValue);
					return (
						<th colSpan={column.colSpan} {...events} {...otherProps} scope="row">
							<div {...ariaProps}>
								{cellValueComponent}
								{superscripts && <Superscript>{superscripts.join(',')}</Superscript>}
								{tooltipProps &&
									tooltipProps.map((props, index) => <Tooltip key={`tooltip_${index}`} {...props} />)}
							</div>
						</th>
					);
				}}
			</TranslationContext.Consumer>
		);
	}
}

export default InjectedStyledComponent(
	observer(RowHeadCell),
	ROW_HEAD_CELL_CATEGORY_KEY,
	ROW_HEAD_CELL_PARENT_COMPONENT_KEY,
	[ROW_HEAD_CELL_COMPONENT_KEY],
);
